import PropTypes from 'prop-types'
import React from 'react'

const ReportIcon = ({
   className,
   color,
   width,
   height,
   strokeWidth
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24">
      <g
         className={className}
         strokeLinecap="round"
         strokeLinejoin="round"
         strokeWidth={strokeWidth}
         fill={color}
         stroke={color}>
         <rect
            x="1"
            y="3"
            width="22"
            height="18"
            fill="none"
            strokeMiterlimit="10"
         />
         <line
            x1="6"
            y1="8"
            x2="18"
            y2="8"
            fill="none"
            strokeMiterlimit="10"
         />
         <line
            x1="6"
            y1="12"
            x2="18"
            y2="12"
            fill="none"
            strokeMiterlimit="10"
         />
         <line
            x1="6"
            y1="16"
            x2="11"
            y2="16"
            fill="none"
            strokeMiterlimit="10"
         />
      </g>
   </svg>
)

ReportIcon.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   strokeWidth: PropTypes.string,
   width: PropTypes.string
}

ReportIcon.defaultProps = {
   className: undefined,
   color: '#444',
   height: '24px',
   strokeWidth: '1',
   width: '24px'
}

export default React.memo(ReportIcon)
